import api from "../../../../services/api";

const getSignature = () => localStorage.getItem("signature");

const post = async (path: string, body: Record<string, any>) => {
  const response = await api.post(path, {
    signature: getSignature(),
    ...body,
  });
  return response.data?.data;
};

export const saveFilter = async (
  companyId: string,
  companyType: string,
  payload: Record<string, any>
) =>
  post("projectService/filter/saveFilter", {
    company_id: companyId,
    company_type: companyType,
    ...payload,
  });

export const updateFilter = async (
  companyId: string,
  companyType: string,
  id: number,
  payload: Record<string, any>
) =>
  post("projectService/filter/updateFilter", {
    company_id: companyId,
    company_type: companyType,
    id,
    ...payload,
  });

export const deleteFilter = async (
  companyId: string,
  companyType: string,
  id: number
) =>
  post("projectService/filter/deleteFilter", {
    company_id: companyId,
    company_type: companyType,
    id,
  });

export const listMine = async (
  companyId: string,
  companyType: string,
  projectId?: number
) =>
  post("projectService/filter/listMine", {
    company_id: companyId,
    company_type: companyType,
    ...(projectId ? { project_id: projectId } : {}),
  });

export const listShared = async (
  companyId: string,
  companyType: string,
  projectId?: number
) =>
  post("projectService/filter/listShared", {
    company_id: companyId,
    company_type: companyType,
    ...(projectId ? { project_id: projectId } : {}),
  });

export const advancedSearch = async (
  companyId: string,
  companyType: string,
  payload: Record<string, any>
) =>
  post("projectService/issue/advancedSearch", {
    company_id: companyId,
    company_type: companyType,
    ...payload,
  });
